import React, { useState } from 'react';

import Link from '@buyside/components/presentation/Link/link';
import Button, { BUTTON_TYPES } from '@buyside/components/presentation/Button/button';

import { ActivityFeedEmployerProfilePressFragment, Maybe } from '@interfaces/graphql-typings';

import styles from './fundUpdatePressMediaItemStyles.scss';

const FundUpdatePressMediaItem: React.FC<{
  item?: Maybe<ActivityFeedEmployerProfilePressFragment>;
}> = ({ item }): React.ReactElement => {
  const [expanded, setExpanded] = useState(false);

  const toggleExpand = (): void => setExpanded(!expanded);

  let buttonText = '(show more)';
  let description = item?.description;

  if (expanded) buttonText = '(show less)';
  if (description && description?.length > 180 && !expanded)
    description = description?.slice(0, 150).trim() + '...';

  return (
    <div className={styles.fundUpdatePressMediaItem}>
      <h6 className={styles.heading}>
        <Link to={item?.url}>{item?.title}</Link>
      </h6>
      <p className={styles.text}>
        <strong>{item?.publishDate}</strong>
      </p>
      <p className={styles.text}>
        {description}
        {item?.description && item?.description.length > 180 && (
          <Button text={buttonText} type={BUTTON_TYPES.LINK} onClick={toggleExpand} />
        )}
      </p>
    </div>
  );
};

export default FundUpdatePressMediaItem;
